import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools'; // Remove when IAF is migrated to promo v2

export var promotionsByMsa = makeEntityScaffold('SAGA.API.PROMOTIONS_BY_MSA', function (client, msaIdentifier, promoIdentifier, params) {
  return client.promotions.getV3(promoIdentifier, _objectSpread({}, params, {
    msa_identifier: msaIdentifier
  })).then(function (promo) {
    return [promo];
  });
}, {
  defaultKey: [1, 2]
});
export var promotionByAlias = makeEntityScaffold('SAGA.API.PROMOTION_BY_ALIAS', function (client, promoAlias, msaId, params) {
  return client.promotions.getPromotionByAlias(promoAlias, _objectSpread({}, params, msaId ? {
    msa_id: msaId
  } : {}));
}, {
  defaultKey: function defaultKey(client, promoAlias, msaId) {
    return msaId ? "".concat(promoAlias, "_").concat(msaId) : promoAlias;
  }
});
export var msaOfferById = makeEntityScaffold('SAGA.API.MSA_OFFER_BY_ID', function (client, msaOfferId, params) {
  return client.promotions.getMsaOfferById(msaOfferId, params);
}, {
  defaultKey: 1
});
export var defaultPromotion = makeEntityScaffold('SAGA.API.DEFAULT_PROMOTION', function (client, state, msaId) {
  var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'web';
  return client.promotions.getDefaultPromotionForState(state, _objectSpread({
    platform: platform
  }, msaId ? {
    msa_id: msaId
  } : {})).then(function (data) {
    return data && _objectSpread({}, data, data.content);
  });
}, {
  defaultKey: [1, 2]
});